// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2BdFc","modalFooterButton":"ModalNotes_modalFooterButton__3Dngv"};